import { LOG_OUT } from '../../actionTypes'

export const logOut = () => (dispatch) => {
  localStorage.clear()
  dispatch({ type: LOG_OUT })
}
